/* Native Broadcast custom elements own menu, sliderules, search, and cart. */
(() => {
  const header = document.querySelector('[data-ep-shell]');
  if (!header) return;
  const updateCart = count => header.classList.toggle('ep-cart-filled', Number(count) > 0);
  updateCart(header.querySelector('[data-cart-count]')?.getAttribute('data-cart-count'));
  document.addEventListener('theme:cart:change', event => {
    if (typeof event.detail?.cartCount !== 'undefined') updateCart(event.detail.cartCount);
    else if (typeof event.detail?.cart?.item_count !== 'undefined') updateCart(event.detail.cart.item_count);
    else fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {headers:{Accept:'application/json'}})
      .then(response => response.ok ? response.json() : Promise.reject())
      .then(cart => updateCart(cart.item_count)).catch(() => {});
  });
  const counts = header.querySelectorAll('[data-cart-count]');
  const observer = new MutationObserver(() => {
    const count = [...counts].find(element => Number(element.getAttribute('data-cart-count')) > 0);
    updateCart(count ? count.getAttribute('data-cart-count') : 0);
  });
  counts.forEach(element => observer.observe(element, {attributes:true,attributeFilter:['data-cart-count']}));
})();
/* Owned source settled desktop switch: mobile through1440, desktop at1600 after a fresh loaded-font reference page.
   The native text-fit estimate varies with translated labels and font loading. */
customElements.whenDefined('header-component').then(() => {
 const header=document.querySelector('[data-ep-shell]');
 if(!header)return;
 const measure=()=>{
  header.minWidth=1500;
  header.checkWidth();
  requestAnimationFrame(()=>{
   const row=header.querySelector('[data-header-height]');
   if(row)document.documentElement.style.setProperty('--header-height',Math.round(row.getBoundingClientRect().height)+'px');
  });
 };
 measure();document.fonts.ready.then(measure);
 window.addEventListener('resize',measure,{passive:true});
 new ResizeObserver(measure).observe(header.querySelector('[data-header-height]'));
});
